import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import Navigation from './components/layout/Navigation';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Products from './components/products/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Favorites from './pages/Favorites';
import Process from './pages/Process';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import ShippingPolicy from './pages/policies/ShippingPolicy';
import ReturnPolicy from './pages/policies/ReturnPolicy';
import DistanceSalesAgreement from './pages/policies/DistanceSalesAgreement';
import KVKK from './pages/policies/KVKK';
import TermsConditions from './pages/policies/TermsConditions';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { ProductProvider } from './context/ProductContext';
import { AuthProvider } from './context/AuthContext';
import { CollectionProvider } from './context/CollectionContext';
import { AnalyticsProvider } from './context/AnalyticsContext';
import AnalyticsInitializer from './components/AnalyticsInitializer';
import { PrivateRoute } from './components/PrivateRoute';
import ScrollToTop from './components/utils/ScrollToTop';
import './App.css';
import Checkout from './pages/Checkout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminPanel from './pages/admin/AdminPanel';
import PaymentSuccess from './pages/PaymentSuccess';
import CashOnDeliverySuccess from './pages/CashOnDeliverySuccess';
import { PaymentProvider } from './context/PaymentContext';
import { OrderProvider } from './context/OrderContext';
import PaymentError from './pages/PaymentError';
import Orders from './pages/Orders';
import Register from './pages/Register';
import ProductDetail from './components/products/ProductDetail';
import OrderSearch from './pages/OrderSearch';
import CustomDesign from './pages/CustomDesign';
import NotFound from './pages/NotFound';
import FloatingSupport from './components/Chat/FloatingSupport';
import Shipping from './pages/Shipping';
import ReturnRequests from './pages/ReturnRequests';
import FAQ from './pages/FAQ';
import { ApiPromptsProvider } from './context/ApiPromptsContext';
import MaintenanceCheck from './components/MaintenanceCheck';

function App() {
  return (
    <Router>
      <AuthProvider>
        <AnalyticsProvider>
          <ProductProvider>
            <CollectionProvider>
              <CartProvider>
                <FavoritesProvider>
                  <PaymentProvider>
                    <OrderProvider>
                      <ApiPromptsProvider>
                      <AnalyticsInitializer />
                      <ScrollToTop />
                      <Toaster position="top-center" reverseOrder={false} />
                      <div className="app-container">
                        <Navigation />
                        <main className="main-content">
                          <MaintenanceCheck>
                            <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/favorites" element={<Favorites />} />
                            <Route path="/process" element={<Process />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/shipping" element={<Shipping />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route 
                              path="/profile" 
                              element={
                                <PrivateRoute>
                                  <Profile />
                                </PrivateRoute>
                              } 
                            />
                            <Route path="/custom-design" element={<CustomDesign />} />
                            {/* Politika Sayfaları */}
                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/shipping-policy" element={<ShippingPolicy />} />
                            <Route path="/return-policy" element={<ReturnPolicy />} />
                            <Route path="/distance-sales-agreement" element={<DistanceSalesAgreement />} />
                            <Route path="/kvkk" element={<KVKK />} />
                            <Route path="/terms-conditions" element={<TermsConditions />} />
                            <Route 
                              path="/admin" 
                              element={
                                <ProtectedAdminRoute>
                                  <AdminPanel />
                                </ProtectedAdminRoute>
                              } 
                            />
                            <Route 
                              path="/payment/success" 
                              element={<PaymentSuccess key={Date.now()} />} 
                            />
                            <Route 
                              path="/payment/cod-success" 
                              element={<CashOnDeliverySuccess key={Date.now()} />} 
                            />
                            <Route path="/payment/error" element={<PaymentError />} />
                            <Route path="/orders" element={
                              <PrivateRoute>
                                <Orders />
                              </PrivateRoute>
                            } />
                            <Route path="/orders/search" element={<OrderSearch />} />
                            <Route path="/return-requests" element={
                              <PrivateRoute>
                                <ReturnRequests />
                              </PrivateRoute>
                            } />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="*" element={<NotFound />} />
                          </Routes>
                          </MaintenanceCheck>
                        </main>
                        <Footer />
                        <FloatingSupport />
                        <ToastContainer
                          position="top-right"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                        />
                      </div>
                      </ApiPromptsProvider>
                    </OrderProvider>
                  </PaymentProvider>
                </FavoritesProvider>
              </CartProvider>
            </CollectionProvider>
          </ProductProvider>
        </AnalyticsProvider>
      </AuthProvider>
    </Router>
  );
}

export default App; 